import React from 'react';

export type Props = {
  className?: string;
  height?: number;
  onClick?(): void;
  width?: number;
};

export const BarCode = React.memo((props: Props) => {
  const {
    width = 56,
    height = 36,
    className,
    onClick,
  } = props;

  return (
    <svg
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      viewBox='0 0 56 36'
      fill='none'
    >
      <rect width='56' height='36' rx='2' fill='#F5F5F6' />
      <rect x='17' y='26' width='21' height='2' rx='1' fill='#E23378' />
      <rect x='21.1819' y='9' width='1' height='13' rx='0.5' fill='#0F0A1B' />
      <rect x='23.1819' y='9' width='1' height='13' rx='0.5' fill='#0F0A1B' />
      <rect x='26.1819' y='9' width='1' height='13' rx='0.5' fill='#0F0A1B' />
      <rect x='28.1819' y='9' width='1' height='13' rx='0.5' fill='#0F0A1B' />
      <rect x='31.1819' y='9' width='1' height='13' rx='0.5' fill='#0F0A1B' />
      <rect x='33.1819' y='9' width='1' height='13' rx='0.5' fill='#0F0A1B' />
      <rect x='36.1819' y='9' width='2' height='13' rx='1' fill='#0F0A1B' />
      <rect x='17.1819' y='9' width='2' height='13' rx='1' fill='#0F0A1B' />
    </svg>
  );
});

BarCode.displayName = 'BarCode';
